export default "__VITE_ASSET__fFzvHh1H__"